import { render, staticRenderFns } from "./EmpProvidersTemplate.vue?vue&type=template&id=02d79e42&"
import script from "./EmpProvidersTemplate.vue?vue&type=script&lang=js&"
export * from "./EmpProvidersTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports